import { AppData, Colors, Img, Lightning, Log, Router, Utils } from '@lightningjs/sdk'
import { List } from '@lightningjs/ui'
import { Channel } from '../../lib/app-api-config'
import { AppSetup } from '../../lib/app-setup'
import AppModel from '../../lib/models/app-model'
import MenuItem from '../../ui-elements/menu-item'
import { Logger } from '../../lib/logger'
import { Helper } from '../../lib/helper'
import { Icon, utils } from '@lightningjs/ui-components'
import { channel } from 'diagnostics_channel'
import { Platform } from '../../platforms/platform'
import { IDialogueButton, IDialogueInfo } from '../../lib/interfaces'
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE } from '../../lib/enum'
import { KeyCodes } from '../../lib/key-codes'


export interface MenuWidgetTemplateSpec extends Lightning.Component.TemplateSpecLoose {
  MenuWrapper: {
    MenuList: List,
  },
  OptionsMenu: {
    MenuItemIcon: {}
  }
}

export default class MenuWidget
  extends Lightning.Component<MenuWidgetTemplateSpec>
  implements Lightning.Component<MenuWidgetTemplateSpec> {

  MenuWrapper = this.getByRef('MenuWrapper')!
  MenuList = this.getByRef('MenuList')!
  menuItems: any[] = []
  index = -1
  page: any
  l1menuCategory: number[] = []


  static override _template(): Lightning.Component.Template<MenuWidgetTemplateSpec> {
    return {
      x: 0,
      y: 0,
      w: 142,
      h: 1080,
      clipping: true,
      zIndex: 30,
      Background: {
        w: (w) => w,
        h: (h) => h,
        rect: true,
        zIndex: 41,
        collision: true
      },
      Line: {
        x: 141,
        w: 1,
        h: (h) => h,
        rect: true,
        color: 0xffffffff,
      },
      MenuWrapper: {
        x: 0,
        y: 220,
        h: 715,
        w: (w) => w,
        clipping: true,
        zIndex: 42,
        collision: true,
        MenuList: {
          collision: true,
          spacing: 25,
          type: List,
          autoResize: true,
          forceLoad: true,
          direction: 'column',
          signals: { onIndexChanged: true },
        },
      },
      OptionsMenu: {
        x: 0,
        y: 925,
        zIndex: 43,
        MenuItemIcon: {
          rtt: false,
          x: 50,
          y: 10,
          w: 72,
          h: 72,
          rect: true,
          color: 0x00000000,
          Icon: {
            w: 72,
            h: 72,
            icon: '',
            type: Icon,
            style: {
              color: '#ffffff'
            }
          },
        },
        MenuItemName: {
          x: 156,
          y: 20,
          w: 554,
          h: 60,
          text: { text: 'OPTIONS', fontSize: 28, fontFace: Helper.getFontFamily('Regular'), textColor: 0xff999999, textOverflow: 'hidden' },
        },
        MenuItemDisp: {
          x: 142,
          y: 55,
          w: 554,
          h: 60,
          text: { text: '', fontSize: 24, fontFace: Helper.getFontFamily('Regular'), textColor: 0xff999999, textOverflow: 'hidden' },
        },
      }
    }

  }

  override _init() {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig()
    this.tag('MenuList').scroll = {
      after: 7, //start scrolling after 3 items
      //jump: 5, //after three items jump three Items
      forward: 0.9, //unless last item: scroll forward if item bounds are after 90% of the List, or if value is above 1; scroll after f.e. 900 pixels
      backward: 0.1, //unless first item: scroll backward if item bounds are before 10% of the List, or if value is above 1; scroll before f.e. 50 pixels
    }
  }

  loadHome() {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()!
    this.index = 1
    this._updateSelected()
    const channel: any = app.appApiConfig.appConfig?.channels[this.l1menuCategory[this.index]] as Channel
    Logger.processUserAction('newL1Clicked', channel.name);
    this.hideMenu();
    Router.navigate('main-grid-screen/' + this.l1menuCategory[this.index] + '/1', false)
    Helper.resetPageAsNew()
  }

  $ItemSelected() {
    const { appConfig, appState, platform } = AppData as AppSetup
    const app = appState?.getApp()!
    const itemType = this.menuItems[this.index].item.menuType
    if (this.menuItems[this.index].item.channel.blockItem) {
      this.page.widgets.notification.showMessage('')
      this.hideMenu();
      Router.focusWidget('notification');
      return;
    }
    switch (itemType) {
      case 'l1':
        this._updateSelected()
        const channel: any = app.appApiConfig.appConfig?.channels[this.l1menuCategory[this.index]] as Channel
        Logger.processUserAction('newL1Clicked', channel.name);
        this.hideMenu();
        Router.navigate('main-grid-screen/' + this.l1menuCategory[this.index] + '/1', false)
        Helper.resetPageAsNew()
        break;
      case 'search':
        Logger.processUserAction('showingSearchScreenOnGrid', '');
        appConfig.searchInput = appConfig?.defaultSearchInput;
        appConfig.useHistory = false;
        this.hideMenu();
        Router.navigate('search-screen/grid', false)
        Helper.resetPageAsNew()
        platform?.textToSpeach('Opening search box')
        break;
      // case 'more':
      //   Logger.processUserAction('showingMoreScreenOnGrid', '');
      //   this.hideMenu();
      //   // Router.navigate('more-screen/4/1', false)
      //   // Helper.resetPageAsNew()
      //   // this.page.widgets.menu.hideMenu()
      //   Router.focusWidget('About')
      // break;
      case 'more':
        this._updateSelected()
        Logger.processUserAction('showingSettingsScreen', '');
        this.hideMenu();
        Router.navigate('settings-screen/grid', false)
        Helper.resetPageAsNew()
        platform?.textToSpeach('Opening setting screen')
        break;
    }

  }

  /**
   * function return boolean if the selected menu can be blocked
   * using the parameter canBlock in the menu ui
   * canBlock will be set as fall for Search and home/first menu.
   * This determines to show the element in the Option menu.
   * @returns {boolean}
   */
  canBlockMenu() {
    const item = this.menuItems[this.index].item
    if (!item.canBlock) {
      return false
    }
    return true
  }

  /**
   * function return current focused menu item to use in Options menu action for block/unblock.
   *
   * @returns {*}
   */
  getCurrentFocusedMenu() {
    const item = this.menuItems[this.index].item;
    return item
  }

  /**
   * function updates the ui by showing/hiding  block icon over selected menu
   *
   * @param {string} action
   */
  updateMenuItem(action: string) {
    const item = this.menuItems[this.index].item
    item.channel.blockItem = action == 'block' ? true : false;
    this.tag('MenuList').items[this.index].patch({
      item: item
    })
  }

  _updateSelected() {
    this.menuItems.map((channel, index) => {
      channel.itemSelected = index == this.index ? true : false
    })
    //this.tag('MenuList').reload(this.menuItems)
    this.tag('MenuList').setIndex(this.index, { immediate: true })
  }

  onIndexChanged(indexData: any) {
    //console.log('onIndexChanged: ', indexData)
    this.index = indexData.index

    const focusedItemName = this.menuItems[this.index]?.item?.channel?.name;
    if (focusedItemName) {
      const { platform } = AppData as AppSetup;
      platform?.textToSpeach(focusedItemName);
    }
  }


  override _getFocused():
    | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
    | null
    | undefined {
    Log.info('MenuWidget: _getFocused fired')
    return this.tag('MenuList')
  }


  expandMenu() {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    this.smooth = { w: 554 }
    this.tag('Line').smooth = { x: 553 }
    this.tag('MenuList').smooth = { w: 553 }
    this.tag('Background').smooth = { alpha: appApiConfig?.appLayoutConfig.menuBgOpacityOpen / 100 }
    this.tag('MenuList').items.map(item => {
      item.setSmooth('w', 553)
    })
  }

  collapseMenu() {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    this.smooth = { w: 142 }
    this.tag('Line').smooth = { x: 141 }
    this.tag('MenuList').smooth = { w: 142 }
    this.tag('Background').smooth = { alpha: appApiConfig?.appLayoutConfig.menuBgOpacityClosed / 100 }
    this.tag('MenuList').items.map(item => {
      item.setSmooth('w', 142)
    })
  }

  override _focus(): void {
    Log.info('MenuWidget: _focus fired')
    const currentRoute: string = Router.getActiveRoute()?.split('/')[0]!
    this.expandMenu()
    const { appState, platform } = AppData as AppSetup
    const app = appState?.getApp()
    const channel: any = app?.appApiConfig.appConfig?.channels[this.l1menuCategory[this.index]] as Channel
    let selectIndex = this.l1menuCategory.findIndex(this.findL1, app?.l1CategoryToLoad)
    if (currentRoute === 'settings-screen') {
      selectIndex = this.menuItems.length - 1
    } else if (currentRoute === 'search-screen') {
      selectIndex = 0
    }
    this.index = selectIndex
    //this.index = this.tag('MenuList').index
    this.tag('MenuList').index = this.index;
    // platform?.textToSpeach(channel.name)
    // this.patch({
    //   OptionsMenu:{
    //     MenuItemName: {
    //       text: {fontStyle:"bold",textColor: 0xffff0000},
    //     },
    //   }
    // });
  }

  hideMenu() {
    //fixed for a crash when deeplink mlp is displayed when back from player
    // and user click on About from options from the MLP grid.
    if (this.page) {
      this.page.isMenuFocused = false;
      this._unfocus();
      Router.focusPage();
    }
  }

  override _unfocus(): void {
    if (this.page.isMenuFocused) {
      return;
    }
    Log.info('MenuWidget: _unfocus fired')
    this.collapseMenu()
    // this.patch({
    //   OptionsMenu: {
    //     MenuItemName: {
    //       text: { fontStyle: "normal", textColor: 0xff999999 },
    //     },
    //   }
    // });
  }

  override _handleKey(e: KeyboardEvent): boolean | void {
    Log.info('MenuWidget: _handleKey ', e)
    const { platform } = AppData as AppSetup
    //XFIN-162 - Comcast - Implement alternative way to open star menu for PlatCo
    //Open option menu when 0 is pressed.
    if (e.keyCode == KeyCodes.KEY_LONG_OK) {
      Router.focusWidget('OptionsMenu')
      return true
    }
    if (platform?.isOptionsKey(e)) {
      platform?.textToSpeach('Opening Options Menu')
      Router.focusWidget('OptionsMenu')
      return true
    }
    return false
  }

  override _handleRight() {
    Log.info('MenuWidget: _handleRight fired')
    //this.page.isMenuFocused = false;
    this.hideMenu()
  }

  override _handleLeft() {
    return true
  }

  override _handleUp() {
    return true
  }

  override _handleDown() {
    return true
  }

  _handleHover(target) {
    // console.log('MenuWidget _handleHover: ', target.ref)
    //return false
    if (target.ref === "Menu") {
      Router.focusWidget('menu')
    }
  }

  _handleUnhover(target) {
    // console.log('MenuWidget _handleunhover: ', target.ref)
    if (target.ref === "Menu") {
      this.hideMenu()
    }
  }

  $handleClick(target) {
    Log.info('MenuWidget: ', target)
    if (this.hasFocus()) {
      this.tag('MenuList').setIndex(target.index, { immediate: true })
      this.$ItemSelected()
    } else {
      Router.focusWidget('menu')
    }
  }

  _handleClick(target) {
    Log.info('MenuWidget _handleClick: ', target.ref)
    if (target.ref === "Background") {
      if (!this.hasFocus()) {
        Router.focusWidget('menu')
      }
    }
  }

  _handleScroll(obj) {
    Log.info('MenuWidget _handleScroll: ', obj)
    if (obj && obj.wheelDeltaY && obj.wheelDeltaY > 0) {
      this.tag('MenuList').previous()
    } else {
      this.tag('MenuList').next()
    }
  }


  override _handleBack() {
    this.hideMenu()
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    if(this.l1menuCategory[this.index] !== 0) {
      Router.navigate('main-grid-screen/' + 0, false)
    } else {
      app?.handleAppExit()  
    }
    
    return true
  }

  // handleExitPopupHandler(selected:IDialogueButton) {
  //   const { platform } = AppData as AppSetup    
  //   if(selected.action == DIALOG_BUTTON_ACTION.YES) {
  //     Logger.processUserAction('userExitedViaRemoteDirectlyFromGrid');
  //     platform?.sendMetrics('close',{reason:"user exit on back"})
  //   } else {
  //     Router.focusPage()
  //   }
  // }

  override _firstActive() {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    const appApiConfig = appState?.getAppApiConfig()
    Log.info('MenuWidget:_firstActive')
    this.patch({
      'Background': {
        rect: true,
        color: Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor, 1),
        alpha: appApiConfig?.appLayoutConfig.menuBgOpacityClosed / 100
      },
      'Line': {
        color: Helper.getHexaColor('#ffffff', appApiConfig?.appLayoutConfig.menuLineOpacityClosed / 100)
      },
    })
  }

  // override _active(): void {
  //   setTimeout(()=>{
  //     const page = Router.getActivePage()
  //     const currentRoute: string = Router.getActiveRoute()
  //     console.log('menu _active ', currentRoute, page);
  //   },100)
  // }

  override _onActivated(page: any) {
    setTimeout(() => {
      const currentRoute: string = Router.getActiveRoute()?.split('/')[0]!
      //console.log('menu onActivated ', currentRoute, page);

      this.page = page
      const { appState, platform} = AppData as AppSetup
      const app = appState?.getApp()
      const appApiConfig = appState?.getAppApiConfig()
      const channels = appApiConfig?.appConfig.channels
      Log.info('MenuWidget:_onActivated channels:', channels)
      if (this.menuItems.length == 0) {
        this.tag('Icon').icon = appApiConfig?.appLayoutConfig.optionsIcon
        this.tag('MenuItemName').text.textColor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textcolor)
        this.tag('MenuItemDisp').patch({
          text: {
            text: platform?.getOptionsText(),
            textColor: Helper.getHexaColor(appApiConfig?.appLayoutConfig.textcolor)
          }
        })
        const searchData: Channel = {
          actionkey: '',
          actiontype: '',
          bannerad_image: '',
          blockItem: false,
          category_id: '',
          content_type: '',
          description: '',
          feed_type: '',
          name: 'Search',
          url: ''
        }
        const moreData: Channel = {
          actionkey: '',
          actiontype: '',
          bannerad_image: '',
          blockItem: false,
          category_id: '',
          content_type: '',
          description: '',
          feed_type: '',
          name: 'More',
          url: ''
        }
        this.l1menuCategory.push(-1)
        Log.info('MenuWidget', '_init', page)
        this.menuItems.push({
          w: 600,
          h: 72,
          collision: true,
          type: MenuItem,
          itemSelected: false,
          index: 0,
          zIndex: 44,
          item: {
            menuType: 'search',
            channel: searchData,
            selected: false,
            canBlock: false
          } as Object,
        })
        channels?.map((channel, index) => {
          moreData.moreImage = channel.moreImage
          moreData.moreSelectImage = channel.moreSelectImage
          searchData.search_root_icon = channel.search_root_icon
          searchData.search_root_icon_select = channel.search_root_icon_select

          this.l1menuCategory.push(index)
          this.menuItems.push({
            w: 554,
            h: 72,
            collision: true,
            type: MenuItem,
            itemSelected: false,
            index: index + 1,
            zIndex: 44,
            item: {
              menuType: 'l1',
              channel: channel,
              selected: false,
              canBlock: (index > 0 ? true : false), //setting if this Menu can be blocked by checking only if it is not the first menu(home).
            } as Object,
          })
        })
        this.l1menuCategory.push(this.l1menuCategory.length)
        this.menuItems.push({
          w: 600,
          h: 72,
          type: MenuItem,
          collision: true,
          itemSelected: false,
          index: this.menuItems.length+1,
          zIndex: 44,
          item: {
            menuType: 'more',
            channel: moreData,
            selected: false,
            canBlock: false
          } as Object,
        })
        const selectIndex = this.l1menuCategory.findIndex(this.findL1, app?.l1CategoryToLoad)
        this.menuItems[selectIndex].item.selected = true
        this.tag('MenuList').add(this.menuItems, { immediate: true })
        this.tag('MenuList').setIndex(selectIndex, { immediate: true })
        this.collapseMenu()
      } else {
        let selectIndex = this.l1menuCategory.findIndex(this.findL1, app?.l1CategoryToLoad)
        if (currentRoute === 'settings-screen') {
          selectIndex = this.menuItems.length - 1
        } else if (currentRoute === 'search-screen') {
          selectIndex = 0
        }
        this.menuItems.map((value, index) => {
          if (selectIndex == index) {
            value.item.selected = true
          } else {
            value.item.selected = false
          }
        })
        this.tag('MenuList').reload(this.menuItems)
        this.tag('MenuList').setIndex(selectIndex, { immediate: true })
        this.collapseMenu()
      }
    }, 100);



  }

  findL1(value) {
    return value == this
  }
}
